import Kundenkonto from 'src/pages/Kundenkonto/Kundenkonto'
import { getSitePageBuilderStaticProps } from 'src/pageBuilder/sitePageBuilder'

export default Kundenkonto

export const getStaticProps = getSitePageBuilderStaticProps
